import { Dialog, Transition } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import { Fragment } from "react/jsx-runtime";

interface DeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onYesClick: () => void;
  onNoClick: () => void;
  message: string;
}
export default function DeleteModal({
  isOpen,
  onClose,
  onYesClick,
  onNoClick,
  message,
}: DeleteModalProps) {
  const { t } = useTranslation();
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-[999]" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/30 backdrop-blur-sm" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md z-[9999] transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title
                  as="h3"
                  className="text-lg font-medium leading-6 text-gray-900"
                >
                  {t("Delete Confirmation")}
                </Dialog.Title>
                <div className="mt-2">
                  <p className="text-sm text-gray-500">{message}</p>
                </div>
                <div className="mt-4 flex flex-row justify-end gap-2">
                  <button
                    onClick={onYesClick}
                    className={`bg-red-600/85  disabled:bg-[#6d9adf] disabled:bg-opacity-50  disabled:cursor-not-allowed  text-white hover:bg-red-600  font-semibold rounded-md  py-2 px-4 `}
                  >
                    {t("Yes")}
                  </button>
                  <button
                    onClick={onNoClick}
                    className={`bg-gray-500/80 disabled:bg-[#6d9adf] disabled:bg-opacity-50  disabled:cursor-not-allowed text-white hover:bg-gray-500  font-semibold rounded-md  py-2 px-4 `}
                  >
                    {t("No")}
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
